"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClientRectHeight = void 0;
const react_1 = require("react");
/**
 * A React hook for measuring the height of a DOM node.
 *
 * Example usage:
 *
 * const [height, refCallback] = useClientRectHeight();
 * <div ref={refCallback} />
 *
 * The `height` value will be updated to the node's height when the refCallback
 * is fired.
 *
 * @returns [height: number | null, refCallback: (node: HTMLElement | null) => void]
 */
const useClientRectHeight = () => {
    const [height, setHeight] = (0, react_1.useState)(null);
    const refCallback = (0, react_1.useCallback)((node) => {
        if (node !== null) {
            setHeight(node.getBoundingClientRect().height);
        }
    }, []);
    return [height, refCallback];
};
exports.useClientRectHeight = useClientRectHeight;
//# sourceMappingURL=useClientRectHeight.js.map